import { white } from '../../colors';

export default {
	expandIcon: {
		color: white,
	},
};
